import { DosageTemplateQuery } from '@dreryk/egabinet-prescription-frontend-api';

import { TextPattern } from '@dreryk/watermelon';

import { ExtendedDosageFormBean } from '../../prescriptions/prescription/extendedDosage/form/ExtendedDosageForm.types';
import { mapExtendedDosageToFormBean } from '../../prescriptions/prescription/extendedDosage/extendedDosage.utils';

import { DosageTemplateListItem } from './DosageTemplates.types';

// A template does not store the portion unit nor the patient instruction, so they are always empty in the form
export const createDosageTemplateFormBeanInitializer = (
   template: DosageTemplateListItem | undefined
) => (): ExtendedDosageFormBean => ({
   ...mapExtendedDosageToFormBean(template?.extendedDosage ?? null, null, null),
   templateName: template?.name ?? null,
});

export const createDosageTemplateQuery = (searchText?: string | null): DosageTemplateQuery => {
   const query = new DosageTemplateQuery();
   if (searchText) {
      query.name = TextPattern.anywhereIgnoreCase(searchText);
   }
   return query;
};
